/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AllStateResponseDto,
  CityResponseDto,
  CountryResponseDto,
  ErrorResponse,
  StateResponseDto,
} from '../models/index';
import {
    AllStateResponseDtoFromJSON,
    AllStateResponseDtoToJSON,
    CityResponseDtoFromJSON,
    CityResponseDtoToJSON,
    CountryResponseDtoFromJSON,
    CountryResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    StateResponseDtoFromJSON,
    StateResponseDtoToJSON,
} from '../models/index';

export interface GetCitiesByStateAndCountryRequest {
    countryIso: string;
    stateIso?: string;
}

export interface GetStatesByCountryRequest {
    countryIso: string;
}

/**
 * 
 */
export class CountryStateCityApi extends runtime.BaseAPI {

    /**
     * Get cities by state and country
     */
    async getCitiesByStateAndCountryRaw(requestParameters: GetCitiesByStateAndCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CityResponseDto>>> {
        if (requestParameters['countryIso'] == null) {
            throw new runtime.RequiredError(
                'countryIso',
                'Required parameter "countryIso" was null or undefined when calling getCitiesByStateAndCountry().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['countryIso'] != null) {
            queryParameters['countryIso'] = requestParameters['countryIso'];
        }

        if (requestParameters['stateIso'] != null) {
            queryParameters['stateIso'] = requestParameters['stateIso'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/country-state-city/cities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CityResponseDtoFromJSON));
    }

    /**
     * Get cities by state and country
     */
    async getCitiesByStateAndCountry(requestParameters: GetCitiesByStateAndCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CityResponseDto>> {
        const response = await this.getCitiesByStateAndCountryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get countries
     */
    async getCountriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CountryResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/country-state-city`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CountryResponseDtoFromJSON));
    }

    /**
     * Get countries
     */
    async getCountries(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CountryResponseDto>> {
        const response = await this.getCountriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all states
     */
    async getStatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AllStateResponseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/country-state-city/states`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AllStateResponseDtoFromJSON));
    }

    /**
     * Get all states
     */
    async getStates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AllStateResponseDto>> {
        const response = await this.getStatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get states by country
     */
    async getStatesByCountryRaw(requestParameters: GetStatesByCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StateResponseDto>>> {
        if (requestParameters['countryIso'] == null) {
            throw new runtime.RequiredError(
                'countryIso',
                'Required parameter "countryIso" was null or undefined when calling getStatesByCountry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/country-state-city/countries/{countryIso}/states`.replace(`{${"countryIso"}}`, encodeURIComponent(String(requestParameters['countryIso']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StateResponseDtoFromJSON));
    }

    /**
     * Get states by country
     */
    async getStatesByCountry(requestParameters: GetStatesByCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StateResponseDto>> {
        const response = await this.getStatesByCountryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
